// extracted by mini-css-extract-plugin
export var container = "_5x-0";